import { Card, Divider } from '@blueprintjs/core';
import { comment } from '@axo/shared/data-access/types';
import {
  CreatorTag,
  CommentIcon,
  CreatedAtTag,
  FollowupTag,
} from '../CommunicationItem';
import cardClasses from '../CommunicationItem/Card.module.css';

interface IUserCommentCardView {
  comment: comment.UserComment;
}

/**
 * Read-only card for a customer (user) comment — a separate entity from
 * agent comments, with no ACE edit/delete/resolve. Visually distinguished
 * via the `cardCustomer` modifier and a "CUSTOMER" author tag.
 */
export function UserCommentCardView({ comment }: IUserCommentCardView) {
  return (
    <Card className={`${cardClasses.card} ${cardClasses.cardCustomer}`}>
      <div className={cardClasses.topBar}>
        <CommentIcon />
        <CreatorTag customValueOverride="CUSTOMER" />
        <CreatedAtTag label="Commented at:" createdAt={comment.CreatedAt} />
        <div className={cardClasses.fill} />
      </div>
      <Divider />
      <div className={cardClasses.body}>
        <div>{comment.Body}</div>
      </div>
      <div className={cardClasses.bottomRow}>
        <FollowupTag followupAt={comment.FollowupAt} resolvedAt={undefined} />
        <div className={cardClasses.fill} />
      </div>
    </Card>
  );
}
